<template lang="pug">
.order-limit-alert(:class="classes")
  template(v-if="type === LIMIT_TYPES.NONE")
    i.bx.bx-check-circle
    span No minimum purchase is required.

  template(v-else-if="type === LIMIT_TYPES.MOQ")
    i.bx.bx-plus-circle
    span The minimum purchase is&nbsp;
      strong {{ value | int }} cases.

  template(v-else-if="type === LIMIT_TYPES.MOV")
    i.bx.bx-dollar-circle
    span The minimum purchase is&nbsp;
      strong {{ value | cents(true, false) }}.
</template>

<script>
import { LIMIT_TYPES } from '~/settings'

export default {
  props: {
    type: {
      type: String,
      default: LIMIT_TYPES.NONE
    },

    value: {
      type: Number,
      default: null
    }
  },

  computed: {
    LIMIT_TYPES: () => LIMIT_TYPES,

    classes () {
      return {
        [`order-limit-alert--${this.type}`]: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-limit-alert {
  display: inline-flex;
  flex-direction: row;
  gap: 4px;
  padding: 3px 10px 3px 4px;
  border-radius: 16px;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .2px;
  &--none {
    background: $--color-success;
    color: white;
  }
  &--mov,
  &--moq {
    background: #fff7df;
    color: #ca8706;
  }
  i {
    font-size: 24px;
  }
}
</style>
